export class Document {
  public key: string;
  public name: string;
  public lastModified: Date;

  constructor(key: string, name: string, lastModified: Date) {
    this.key = key;
    this.name = name;
    this.lastModified = lastModified;
  }
}
